import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentServiceCenter on ServiceCenter {
    id
    name
    code
    functionalizations {
      functionId
      percent
    }
    assignedSpaceIds
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentServiceCenterFragment,
  ents.extra.space.ServiceCenter
>({
  assignedSpaceIds: graphql.transformers.OUT.default(
    graphql.transformers.OUT.list(
      graphql.transformers.OUT.validate(
        transformers.PASS_THROUGH,
        ents.extra.space.Record.Id.isId,
      ),
      { onNullish: 'remove' },
    ),
    [],
  ),
  code: transformers.PASS_THROUGH,
  functionalizations: graphql.transformers.OUT.default(
    graphql.transformers.OUT.list(
      graphql.transformers.OUT.object({
        functionId: graphql.transformers.OUT.validate(
          transformers.PASS_THROUGH,
          ents.extra.space.Function.Id.isId,
        ),
        percent: transformers.PASS_THROUGH,
      }),
      { onNullish: 'remove' },
    ),
    [],
  ),
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.extra.space.ServiceCenter.Id.isId,
  ),
  name: transformers.PASS_THROUGH,
})
